import { useEffect, type RefObject } from "react"

/** Escape closes, and focus goes back to where it was when the dialog opened. Focuses `initial` if given. */
export function useDialogFocus(onClose: () => void, initial?: RefObject<HTMLElement>) {
  useEffect(() => {
    const opener = document.activeElement as HTMLElement | null
    initial?.current?.focus()
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return
      e.stopPropagation()
      onClose()
    }
    document.addEventListener("keydown", onKey)
    return () => {
      document.removeEventListener("keydown", onKey)
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true })
    }
    // Runs once per open.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
